import startCase from 'lodash/startCase'

import { sortArrayBy } from '@domain-group/javascript-utils'

import type { DataStoreItemModel } from '@models/types'

import portalDataSchema from '@functions/portalData'
function buildKeys(dataStoreItem: DataStoreItemModel) {
  const { label: rawLabel, group_key } = dataStoreItem

  const keys = {
    group: group_key ? 'Responses' : 'Custom Data',
    isGroupedResponse: !!group_key,
    label: 'Item Label',
    section: group_key || 'Data Section',
  }

  if (rawLabel){
    const parts = rawLabel.split('/')

    if (parts.length === 1){
      const [label] = parts
      keys.label = label
    }

    if (parts.length === 3){
      const [group, section, label] = parts
      keys.group = group
      keys.section = section
      keys.label = label
    }
  }

  return keys
}

export function stripItemLabel(rawLabel: string) {
  if (!rawLabel) return ''

  const split = rawLabel.split('/').reverse()

  return split[0] || ''
}

const portalDataLabelsByKey = portalDataSchema.fields.reduce<Record<string, string>>((acc, field) => {
  acc[field.key] = field.label
  return acc
}, {})

function retrieveLabelFromPortalData(key: DataStoreItemModel['key']) {
  const stringKey = String(key ?? '')
  return portalDataLabelsByKey[stringKey] || (stringKey ? startCase(stringKey) : '')
}

export interface DataStoreItemData extends DataStoreItemModel {
  display_label: string,
}

export type DataStoreItemSection = {
  [key: string]: {
    key: string,
    isGroupedResponse: boolean,
    items: {
      key: string,
      data: DataStoreItemData,
    }[],
  },
};

export type DataStoreItemGroup = {
  [key: string]: {
    key: string,
    sections: DataStoreItemSection,
  },
}

function groupDataStoreItems(dataStoreItems: DataStoreItemModel[]) {
  const groups: DataStoreItemGroup = {}

  if (dataStoreItems && dataStoreItems.length){
    dataStoreItems.forEach((dataStoreItem) => {
      const {
        isGroupedResponse, group: groupKey, section: sectionKey, label: labelKey,
      } = buildKeys(dataStoreItem)

      if (!groups[groupKey]){
        groups[groupKey] = {
          key: groupKey,
          sections: {},
        }
      }

      if (!groups[groupKey].sections[sectionKey]){
        groups[groupKey].sections[sectionKey] = {
          key: sectionKey,
          isGroupedResponse,
          items: [],
        }
      }

      groups[groupKey].sections[sectionKey].items.push({
        key: labelKey,
        data: {
          ...dataStoreItem,
          // @ts-expect-error TS2345
          display_label: stripItemLabel(dataStoreItem.label) || retrieveLabelFromPortalData(dataStoreItem.key),
        },
      })

      sortArrayBy(groups[groupKey].sections[sectionKey].items, 'asc', 'key')
    })
  }

  return groups
}

export default groupDataStoreItems
